module.exports = {"140923100":"上馆镇","140923101":"阳明堡镇","140923102":"峨口镇","140923103":"聂营镇","140923104":"枣林镇","140923105":"滩上镇","140923200":"新高乡","140923201":"峪口乡","140923202":"上磨坊乡","140923203":"胡峪乡","140923204":"雁门关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140923.json
// module id = 349
// module chunks = 0